import Api from "../../api";

import placeCategoryService from "./categories/service";
import { Place, PlacePhoto } from "./models.jsx";

const photosUrl = "/photos";

class PlaceApi extends Api {

	get(placeId, callback) {
		var url = this.baseUrl + "/" + placeId;

		this.client.get(url)
			.then((response) => {
				callback({
					result: new Place(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	search(category, strict, keyword, callback) {
		var url = this.baseUrl;

		this.client.get(url, { params: { category: category, strictCategory: strict, keyword: keyword } })
			.then((response) => {
				var data = [];
				for (var index = 0; index < response.data.length; index++) {
					data.push(new Place(response.data[index]));
				}
				callback({
					result: data,
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	getPage(startItem, endItem, category, strict, keyword, callback) {
		var url = this.baseUrl;
	     
	    this.client.get(url, { 
	    	headers: {"Range": "items=" + startItem + "-" + endItem},
	    	params: { category: category, strictCategory: strict, keyword: keyword } 
	    }).then((response) => {
			var rangeHeader = response.headers["range"];
			var total = parseInt(rangeHeader.split("/")[1]);

			var data = [];
			for (var index = 0; index < response.data.length; index++) {
				data.push(new Place(response.data[index]));
			}

	    	callback({ 
	    		result: { data: data, total: total }, 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}

	delete(placeId, callback) {
		var url = this.baseUrl + "/" + placeId;
		this.client.delete(url)
			.then((response) => {
				callback({
					result: response.data,
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	create(business, callback) {
		var url = this.baseUrl;
		this.client.post(url, business)
			.then((response) => {
				callback({
					result: new Place(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}


	update(business, callback) {
		var url = this.baseUrl + "/" + business.id;
		this.client.put(url, business)
			.then((response) => {
				callback({
					result: new Place(response.data),
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}
}

class PlacePhotosApi extends Api {

	create(placeId, binary, callbacks) {
	    let url = this.baseUrl + "/" + placeId + photosUrl;

	    this.uploadBinary(url, binary, {
	    	onUpdateProgress: callbacks.onUpdateProgress,
	    	success: (result) => { 
	    		callbacks.result({result: new PlacePhoto(result), error: null}) 
	    	},
			error: (error) => { 
				callbacks.result({result: null, error: error}) 
			}
	    });
	}

	delete(placeId, photoId, callback) {
	    let url = this.baseUrl + "/" + placeId + photosUrl + "/" + photoId;

	   	this.client.delete(url)
	   		.then((response) => {
				callback({
					result: response.data,
					error: null
				});
			}).catch((error) => {
				callback({ 
		    		result: null, 
		    		error: this.extractError(error)
		    	});
			});
	}

	url(photo) {
		return this.baseUrl + "/" + photo.placeId + photosUrl + "/" + photo.id;
	}
	
}

class PlacesApi{

	constructor(baseUrl) {
		this.categories = placeCategoryService.api;
		this.places = new PlaceApi(baseUrl);
		this.placePhotos = new PlacePhotosApi(baseUrl);
	}

}


export default PlacesApi;